import { z } from 'zod';
import { alertDefinition } from './alerts.js';

export const telegramLinkTtlMinutes = 30;
export const telegramPromptCode = 'telegram';
export const maxPersonalRules = 50;
export const telegramStartPattern = /^[A-Za-z0-9_-]{16,64}$/;

export const personalRuleInput = z
  .object({
    name: z.string().trim().min(1).max(200),
    template: z.string().max(60).nullable().default(null),
    definition: alertDefinition,
    enabled: z.boolean().default(true),
    cooldownMinutes: z.number().int().min(1).max(10080).default(60),
    notifyRecovery: z.boolean().default(true),
  })
  .strict();
export type PersonalRuleInput = z.input<typeof personalRuleInput>;

export const telegramPromptAction = z
  .object({
    action: z.enum(['skip', 'configure']),
    never: z.boolean().default(false),
  })
  .strict();
export type TelegramPromptAction = z.input<typeof telegramPromptAction>;

export interface TelegramStatus {
  available: boolean;
  botUsername: string | null;
  link: { username: string | null; firstName: string | null; linkedAt: string; blocked: boolean } | null;
  rules: number;
  prompt: boolean;
}

export type TelegramJobData =
  | { kind: 'welcome'; userId: string }
  | { kind: 'test'; userId: string }
  | { kind: 'alert'; deliveryId: string }
  | { kind: 'document'; userId: string; exportId: string };
